<div>
  <div nz-row nzJustify="space-between">
    <app-filters [filters]="auditFilters"
                 [authPermissions]="authPermissions"
                 (filtersChanged)="onFiltersChange($event)"
                 class="flex-1">
    </app-filters>
  </div>
  <ng-container *ngIf="auditData$ | async as auditData">
    <app-table [table]="auditTable"
               [tableColumns] = "auditTableColumns"
               [tableData] = "auditData.data"
               [tableType]="'serverSide'"
               [idProp]="'externalDealId'"
               [authPermissions]="authPermissions"
               [hasSizeChanger]="true"
               [totalRows] = "auditData.totalElements"
               [isPaginated]="true"
               [hasFooter]="true"
               [isTableLoading] = "auditData.isLoading"
               (tablePageChanged)="onTablePageChange($event)"
               (tableSortChanged)="onTableSortChange($event)"
    >
    </app-table>
  </ng-container>
</div>
